import { transformExtent } from 'ol/proj';
import { buildFeatures } from './stations.js';

const API_URL = 'https://api.goingelectric.de/chargepoints';
const API_KEY = '31816b3da82dd54daad285122e84f455';

function getJson(url, formData, callback) {
  const xhr = new XMLHttpRequest();
  xhr.open('POST', url, true);
  xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
  xhr.responseType = 'json';
  xhr.onload = function () {
    if (xhr.status === 200) callback(null, xhr.response);
    else callback(xhr.status, xhr.response);
  };
  xhr.send(formData);
}

export function loadGE(extent, zoom, minLoad, minPoints, lastExtent, filterProblems, onFeatures) {
  const clustering = zoom < 10;

  const formData = new URLSearchParams({
    'plugs[0][type]': 'combo_typ2',
    'plugs[0][min_power]': '' + minLoad,
    'plugs[1][type]': 'tesla_supercharger_ccs',
    'plugs[1][min_power]': '' + minLoad,
    clustering: '' + clustering,
    key: API_KEY,
    ne_lat: '' + extent[3],
    ne_lng: '' + extent[2],
    sw_lat: '' + extent[1],
    sw_lng: '' + extent[0],
    zoom: '' + zoom,
    cluster_distance: '50',
  }).toString();

  getJson(API_URL, formData, function (err, response) {
    if (err || response.status !== 'ok') return;

    let clustered = 0;
    for (const loc of response.chargelocations) {
      if (!loc.chargepoints) clustered += loc.clusterCount || 0;
    }

    const features = buildFeatures(response.chargelocations, zoom, minPoints, minLoad, filterProblems);
    onFeatures(features);

    if (clustered > 0 && clustered < 500) {
      const lonLatExtent = transformExtent(lastExtent, 'EPSG:3857', 'EPSG:4326');
      loadGE(lonLatExtent, 10, minLoad, minPoints, lastExtent, filterProblems, onFeatures);
    }
  });
}
